import React, { useState, useEffect } from 'react';
import Styles from './styles.module.css';
import { getFirestore, query, collection, where, getDocs } from 'firebase/firestore';
import Title from '../title';
import DefaultImage from 'src/image/default/account.png';

type StaffProfile = {
  id: string;
  docId: string;
  name: string;
  position: string;
  message: string;
  instagramId: string;
  tiktokId: string;
};

type RecruitStaffProfilesProps = {
  companyId: string;
};

const RecruitStaffProfiles: React.FC<RecruitStaffProfilesProps> = ({ companyId }) => {

  const [ staffList, setStaffList ] = useState<StaffProfile[]>([]);

  useEffect(() => {
    if (!companyId) return;

    const fetchStaff = async () => {
      const db = getFirestore();
      const q = query(
        collection(db, 'staffProfiles'),
        where('companyId', '==', companyId)
      );
      const snap = await getDocs(q);
      const tmp: StaffProfile[] = snap.docs.map(d => ({
        id: d.id,
        docId: d.data().docId ?? '',
        name: d.data().name ?? '',
        position: d.data().position ?? '',
        message: d.data().message ?? '',
        instagramId: d.data().instagramId ?? '',
        tiktokId: d.data().tiktokId ?? '',
      }));
      setStaffList(tmp);
    };

    fetchStaff();
  }, [companyId]);

  if (staffList.length === 0) return null;

  return (
    <>
      <div className={Styles.hr} />
      <Title title="スタッフ紹介" desc="一緒に働くスタッフを紹介します" />

      <div className={Styles.grid}>
        {staffList.map(staff => (
          <div key={staff.id} className={Styles.card}>

            <img
              className={Styles.avatar}
              src={`https://firebasestorage.googleapis.com/v0/b/trankllc-com.appspot.com/o/staffProfiles%2F${staff.docId}?alt=media`}
              alt={staff.name}
              onError={e => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = DefaultImage;
              }}
            />

            <h4 className={Styles.name}>{staff.name}</h4>

            {staff.position && (
              <p className={Styles.position}>{staff.position}</p>
            )}

            {staff.message && (
              <p className={Styles.message}>{staff.message}</p>
            )}

            <div className={Styles.sns}>
              {staff.instagramId && (
                <a
                  href={`https://www.instagram.com/${staff.instagramId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={Styles.btn_instagram}
                >
                  instagram
                </a>
              )}
              {staff.tiktokId ? (
                <a
                  href={`https://www.tiktok.com/@${staff.tiktokId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={Styles.btn_tiktok}
                >
                  tiktok
                </a>
              ) : (
                <span className={Styles.btn_tiktok} style={{ opacity: 0.2, pointerEvents: 'none' }}>
                  tiktok
                </span>
              )}
            </div>

          </div>
        ))}
      </div>
    </>
  );
};

export default RecruitStaffProfiles;
